import { FC } from 'react';

import { CampaignProcess } from 'utils/constants/campaign';

import useTrls from 'hooks/translation/useTrls';

import { MagritteVacanciesSelect } from 'components/common/MagritteVacanciesSelect';
import { getCampaignType } from 'components/CpcFlexibleCreate/CpcForm/AdCampaignInformation/getCampaignType';
import { fetchBannerByVacancy } from 'components/CpcFlexibleCreate/CpcForm/Vacancies/fetchBannerByVacancy';

import {
    setBannerErrors,
    setBannerLink,
    setBannerVacancyId,
    setClassificationCodeId,
    setVacancyName,
} from 'store/models/createBanner';
import { selectCampaignProcess } from 'store/models/createCampaign';
import { useDispatch, useSelector } from 'store/utils';

export const Vacancies: FC = () => {
    const { campaignIdForBanner, bannerVacancyId, vacancyName, bannerErrors } = useSelector(
        (state) => state.createBanner
    );
    const campaignProcess = useSelector(selectCampaignProcess);

    const dispatch = useDispatch();
    const trl = useTrls();

    const resetVacancy = () => {
        dispatch([setBannerLink(''), setBannerVacancyId(null), setClassificationCodeId(null), setVacancyName('')]);
    };

    const onChange = (value: string, name: string) => {
        if (!value) {
            resetVacancy();
            return;
        }

        const numericValue = Number(value);

        dispatch([setBannerVacancyId(numericValue), setVacancyName(name)]);

        if (bannerErrors.bannerLink) {
            dispatch(setBannerErrors({}));
        }

        dispatch(fetchBannerByVacancy(numericValue, campaignProcess === CampaignProcess.Copy));
        void dispatch(getCampaignType());
    };

    return (
        <MagritteVacanciesSelect
            label={trl('AdCreate.AdForm.Vacancies.label')}
            withClearButton
            currentVacancyId={bannerVacancyId?.toString() || null}
            currentVacancyName={vacancyName}
            chooseVacancy={onChange}
            resetVacancy={resetVacancy}
            disabled={Boolean(campaignIdForBanner)}
            vSpacingBottom={32}
        />
    );
};
